<p-dialog appDialogoPadrao="pi pi-shield" descricao="Conjunto de permissões atribuível a usuários." [header]="modoEdicao() ? 'Editar perfil' : 'Novo perfil'" [visible]="true" [style]="{ width: '64rem', maxWidth: '95vw' }" (onHide)="fechar()">
    @if (carregando()) {
        <div class="p-6 text-center"><i class="pi pi-spin pi-spinner"></i></div>
    } @else {
        <div class="flex flex-col gap-3 mb-4">
            <div class="flex gap-3 flex-wrap items-end">
                <label class="flex flex-col gap-1 text-sm font-medium flex-1 min-w-[16rem]">
                    Nome
                    <input pInputText [ngModel]="nmPerfil()" (ngModelChange)="nmPerfil.set($event)" placeholder="Nome do perfil" />
                    @if (mostrarErroNome()) {
                        <span class="text-xs text-red-500">Campo obrigatório.</span>
                    }
                </label>
                <!-- O tooltip fica no <label>, não no seletor: desabilitado, o host do PrimeNG ganha
                     `.p-disabled { pointer-events: none }` e nunca dispararia o hover. -->
                <label class="flex flex-col gap-1 text-sm font-medium min-w-[15rem]" [pTooltip]="ufTooltip()">
                    UF
                    <app-estado-select [uf]="uf()" (ufChange)="uf.set($event)" [disabled]="ufBloqueada()" />
                </label>
                <label class="flex flex-col gap-1 text-sm font-medium flex-[2] min-w-[16rem]">
                    Descrição
                    <input pInputText [ngModel]="dsPerfil()" (ngModelChange)="dsPerfil.set($event)" placeholder="Descrição do perfil" />
                </label>
                <p-button label="Criar a partir de um usuário" icon="pi pi-user-plus" severity="secondary" [text]="true" size="small" (onClick)="abrirSnapshot()"></p-button>
            </div>

            @if (snapshotAberto()) {
                <div class="border border-surface-200 dark:border-surface-700 rounded-lg p-3 flex flex-col gap-2">
                    <div class="flex items-center justify-between gap-2">
                        <p-iconfield iconPosition="left" class="flex-1">
                            <p-inputicon styleClass="pi pi-search" />
                            <input pInputText type="text" [ngModel]="filtroUsuarioSnapshot()" (ngModelChange)="filtroUsuarioSnapshot.set($event)" placeholder="Buscar usuário por nome ou id..." class="w-full" />
                        </p-iconfield>
                        <p-button icon="pi pi-times" [text]="true" severity="secondary" ariaLabel="Fechar busca" (onClick)="fecharSnapshot()"></p-button>
                    </div>
                    <div class="max-h-40 overflow-auto flex flex-col gap-1">
                        @for (u of usuariosFiltrados(); track u.id) {
                            <div class="flex items-center justify-between gap-2 px-2 py-1.5 rounded hover:bg-surface-100 dark:hover:bg-surface-800">
                                <span class="text-sm truncate"
                                    >{{ u.nmSolicitante || u.userId }} <span class="text-muted-color">({{ u.ufSolicitante }})</span></span
                                >
                                <p-button label="Usar" size="small" [text]="true" (onClick)="selecionarUsuarioSnapshot(u)"></p-button>
                            </div>
                        } @empty {
                            <div class="text-sm text-muted-color px-2 py-1.5">Nenhum usuário encontrado.</div>
                        }
                    </div>
                </div>
            }
            @if (usuarioSnapshotSel(); as u) {
                <div class="text-sm text-muted-color flex items-center gap-1.5">
                    <i class="pi pi-info-circle"></i>
                    Roles pré-marcadas a partir de <strong>{{ u.nmSolicitante || u.userId }}</strong
                    >. Ajuste livremente antes de salvar.
                </div>
            }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-folder" [title]="'Módulos'">
                <div class="flex flex-col gap-1">
                    @for (mod of grupos(); track mod.modulo) {
                        <div class="kanban-item flex justify-between items-center" [class.is-sel]="mod.modulo === moduloSel()" (click)="selecionarModulo(mod)">
                            <span>{{ mod.moduloLabel }}</span>
                            <span class="text-xs text-muted-color">{{ mod.total }}</span>
                        </div>
                    }
                </div>
            </app-card-content>

            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-list" [title]="'Funcionalidades'">
                @if (moduloAtual(); as mod) {
                    <div class="flex flex-col gap-1">
                        @for (f of mod.funcionalidades; track f.funcionalidade) {
                            <div class="kanban-item" [class.is-sel]="f.funcionalidade === funcSel()" (click)="selecionarFunc(f)">{{ f.funcionalidadeLabel }}</div>
                        }
                    </div>
                } @else {
                    <div class="text-muted-color text-sm p-2">Selecione um módulo.</div>
                }
            </app-card-content>

            <app-card-content [border]="true" [headerColor]="true" icon="pi pi-bolt" [title]="'Ações'">
                @if (funcAtual(); as f) {
                    @if (f.crud.length) {
                        <div class="flex items-center justify-between gap-2 px-2 py-2 rounded-lg bg-surface-100 dark:bg-surface-800 mb-2">
                            <span class="text-sm font-medium">Conceder tudo (CRUD)</span>
                            <p-toggleswitch [ngModel]="crudTodas(f)" (ngModelChange)="toggleCrud(f)" />
                        </div>
                        <div class="flex flex-col">
                            @for (a of f.crud; track a.role) {
                                <div class="flex items-center justify-between gap-2 py-2 border-b border-surface-200 dark:border-surface-700 last:border-b-0">
                                    <div class="flex items-center gap-2 min-w-0">
                                        <span class="acao-dot tipo-{{ a.crud }}"></span>
                                        <span class="text-sm truncate">{{ a.acaoLabel }}</span>
                                    </div>
                                    <p-toggleswitch [ngModel]="marcada(a.role)" (ngModelChange)="toggle(a.role)" />
                                </div>
                            }
                        </div>
                    }
                    @if (f.especificas.length) {
                        <div class="text-xs font-semibold uppercase tracking-wide text-muted-color mt-4 mb-1">Específicas</div>
                        <div class="flex flex-col">
                            @for (a of f.especificas; track a.role) {
                                <div class="flex items-center justify-between gap-2 py-2 border-b border-surface-200 dark:border-surface-700 last:border-b-0">
                                    <div class="flex items-center gap-2 min-w-0">
                                        <span class="acao-dot tipo-E"></span>
                                        <span class="text-sm truncate">{{ a.acaoLabel }}</span>
                                    </div>
                                    <p-toggleswitch [ngModel]="marcada(a.role)" (ngModelChange)="toggle(a.role)" />
                                </div>
                            }
                        </div>
                    }
                } @else {
                    <div class="text-muted-color text-sm p-2">Selecione uma funcionalidade.</div>
                }
            </app-card-content>
        </div>
    }

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" (onClick)="fechar()"></p-button>
        <p-button label="Salvar" icon="pi pi-check" [disabled]="salvando()" [loading]="salvando()" [appCan]="rolePermissaoAdministrar" (onClick)="salvar()"></p-button>
    </ng-template>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-shield" descricao="Alinha as roles do perfil com o Keycloak." header="Sincronizar perfil" [visible]="dialogSyncAberto()" [style]="{ width: '30rem', maxWidth: '95vw' }" (onHide)="cancelarSync()">
    @if (syncPreview(); as preview) {
        <div class="flex flex-col gap-3">
            <p class="text-sm">
                <strong>{{ preview.qtdUsuarios }}</strong> usuário(s) têm este perfil. Se você sincronizar, estas roles serão propagadas a eles agora:
            </p>
            @if (preview.adicionadas.length) {
                <div>
                    <div class="text-xs font-semibold uppercase tracking-wide text-green-600 mb-1">Serão adicionadas ({{ preview.adicionadas.length }})</div>
                    <div class="flex flex-col gap-1 max-h-32 overflow-auto">
                        @for (r of preview.adicionadas; track r) {
                            <span class="text-sm font-mono">{{ r }}</span>
                        }
                    </div>
                </div>
            }
            @if (preview.removidas.length) {
                <div>
                    <div class="text-xs font-semibold uppercase tracking-wide text-red-600 mb-1">Serão removidas ({{ preview.removidas.length }})</div>
                    <div class="flex flex-col gap-1 max-h-32 overflow-auto">
                        @for (r of preview.removidas; track r) {
                            <span class="text-sm font-mono">{{ r }}</span>
                        }
                    </div>
                </div>
            }
            <div class="text-xs text-muted-color flex items-center gap-1.5 bg-surface-100 dark:bg-surface-800 rounded-lg px-2 py-2">
                <i class="pi pi-info-circle"></i>
                Roles que algum desses usuários tenha por fora deste perfil não serão afetadas.
            </div>
        </div>
    }
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" (onClick)="cancelarSync()"></p-button>
        <p-button label="Salvar sem sincronizar" severity="secondary" [text]="true" (onClick)="confirmarSalvarSemSync()"></p-button>
        <p-button label="Salvar e sincronizar" icon="pi pi-check" (onClick)="confirmarSalvarComSync()"></p-button>
    </ng-template>
</p-dialog>

<p-confirmdialog></p-confirmdialog>
